import {
  getFaceReseauTempoWithControleDispoAsync,
  getFaceReseauPeriodeWithControleDispoAsync,
} from '@/api/produit/controleDispoFaceReseau';
import getMessageIndispoFace from '@/services/dcf/reseauTempo/getMessageIndispoFace';
import {
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_REGROUPEMENT_MAIRIE,
} from '@/configuration/catalogue/produitConf';
import formatDateIso from '@/services/general/formatIsoDate';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';

async function getProduits(
  ligneCommande, selectionFaceForOption, societeId,
) {
  const dateDebut = ligneCommande.dateDebut;
  let dateFin = ligneCommande.dateFin;
  if (ligneCommande.typeProduit === CATEGORIE_REGROUPEMENT_MAIRIE) {
    dateFin = ligneCommande.dateDebut;
  }
  const payload = {
    societeId,
    selectionFaceForOption,
    ligneCommandeid: ligneCommande.id,
    produitId: ligneCommande.produitId,
    dateFin: formatDateIso(dateFin),
    dateDebut: formatDateIso(dateDebut),
    jourDepart: ligneCommande.ligneReseau.jourDepart || 1,
    anneeSemaine: ligneCommande.ligneReseau.anneeSemaine,
    referenceVentePartielle: ligneCommande.ligneReseau.referenceVentePartielle,
  };
  switch (ligneCommande.typeProduit) {
    case CATEGORIE_REGROUPEMENT:
      return (await getFaceReseauTempoWithControleDispoAsync(payload)).data.result;
    case CATEGORIE_REGROUPEMENT_MAIRIE:
    case CATEGORIE_REGROUPEMENT_LC:
      return (await getFaceReseauPeriodeWithControleDispoAsync(payload)).data.result;
    default:
      throw new Error();
  }
}

async function getProduitsForDemandeAffichage(demande, societeId,
  datePlanification,
) {
  const produitId = demande?.produitId ?? demande?.ligneCommande?.produitId;

  if (!produitId) return [];

  const payload = {
    societeId,
    selectionFaceForOption: false,
    produitId: produitId,
    dateDebut: formatDateIso(datePlanification),
    dateFin: formatDateIso(datePlanification),
    jourDepart: 1,
    anneeSemaine: +getAnneeSemaineFromDate(datePlanification),
    demandeLogistiqueId: demande.id,
  };
  switch (demande.typeProduit) {
    case CATEGORIE_REGROUPEMENT:
      return (await getFaceReseauTempoWithControleDispoAsync(payload)).data.result;
    case CATEGORIE_REGROUPEMENT_MAIRIE:
    case CATEGORIE_REGROUPEMENT_LC:
      return (await getFaceReseauPeriodeWithControleDispoAsync(payload)).data.result;
    default:
      throw new Error();
  }
}

export function sortListeFaces(listeFacesBase) {
  listeFacesBase.sort((a, b) => {
    const compareVille = a.adresse.ville.localeCompare(b.adresse.ville, 'fr', { sensitivity: 'base' });
    if (compareVille === 0) return a.reference.localeCompare(b.reference, 'fr', { sensitivity: 'base' });
    return compareVille;
  });
  return listeFacesBase;
}

export async function getLignesSelectionFace(
  ligneCommande,
  estSelectionEnOption,
  users,
  societeActiveId,
  isDetail) {
  const lignesCmdSel = estSelectionEnOption
    ? ligneCommande.lignesCmdSelOptionProduit
    : (ligneCommande.ligneReseau.lignesCmdSelProduits ?? []);
  const produits = await getProduits(
    ligneCommande, estSelectionEnOption, societeActiveId,
  );
  const lignes = produits.map((p) => {
    const ligneSelFind = lignesCmdSel.find((l) => l.produitId === p.id);
    return {
      actif: p.actif,
      produitId: p.id,
      libelle: p.libelle,
      reference: p.reference,
      format: p.produitFace.format,
      longueur: p.longueur,
      largeur: p.largeur,
      adresse: p.produitFace.adresse,
      ville: p.produitFace.adresse.ville,
      aPatrimoine: !!p.produitFace.faceId,
      disposition: p.produitFace.disposition,
      codePanneau: p.produitFace.codePanneau,
      materielType: p.produitFace.materielType,
      codePostal: p.produitFace.adresse.codePostal,
      restriction: p.produitFace.restrictionsAffichage,
      nonCommercialisable: ligneCommande.typeProduit !== CATEGORIE_REGROUPEMENT_MAIRIE
        && !!p.produitFace.faceMotifNonComId,
      id: p.ligneCmdSelectionId,
      selected: !!ligneSelFind,
      instructionPose: p.instructionPose,
      dispo: p.estDisponible,
      affecteLogistiquement: p.affecteLogistiquement,
      messageIndisponibilite: getMessageIndispoFace(p.messageIndisponibilite, users),
      reseauFaceTags: p.reseauFaceTags,
      selectedForActionGroupee: false,
      autreAffectationLogistique: null,
      formatAfficheId: p.formatAfficheId,
    };
  });
  sortListeFaces(lignes);
  if (isDetail) {
    return lignes.filter((l) => l.selected || l.affecteLogistiquement);
  }
  return lignes;
}

export async function getLignesSelectionFaceForDemandeAffichage(
  demande, users, societeActiveId, datePlanification, demandeLogistiqueId) {
  const produits = await getProduitsForDemandeAffichage(
    demande,
    societeActiveId,
    datePlanification,
    demandeLogistiqueId,
  );
  const lignes = produits.map((p) => {
    return {
      actif: p.actif,
      produitId: p.id,
      libelle: p.libelle,
      reference: p.reference,
      format: p.produitFace.format,
      adresse: p.produitFace.adresse,
      ville: p.produitFace.adresse.ville,
      aPatrimoine: !!p.produitFace.faceId,
      disposition: p.produitFace.disposition,
      codePanneau: p.produitFace.codePanneau,
      materielType: p.produitFace.materielType,
      codePostal: p.produitFace.adresse.codePostal,
      restriction: p.produitFace.restrictionsAffichage,
      nonCommercialisable: !!p.produitFace.faceMotifNonComId,
      id: p.ligneCmdSelectionId,
      selected: false,
      instructionPose: p.instructionPose,
      dispo: p.estDisponible,
      reseauFaceTags: p.reseauFaceTags,
      affecteLogistiquement: p.affecteLogistiquement,
      messageIndisponibilite: getMessageIndispoFace(p.messageIndisponibilite, users),
      selectedForActionGroupee: false,
      autreAffectationLogistique: null,
    };
  });
  sortListeFaces(lignes);
  return lignes;
}
